export default "__VITE_ASSET__Dwmp5daZ__"